import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid , Image , Checkbox , Icon } from 'semantic-ui-react';
import ThemeColorSetting from '../../constants/themeColor';
import summaryDashboardDisplay from '../../assets/feature/summaryDashboard.gif';
import settingDashboardDisplay from '../../assets/feature/settingDashboard.gif';

const deviceDisplay = {
  realTimePerf : summaryDashboardDisplay,
  salesReport : summaryDashboardDisplay,
  productReport : summaryDashboardDisplay,
  restaurant : settingDashboardDisplay,
  workflow : settingDashboardDisplay,
  staff : settingDashboardDisplay,
  serviceCharge : settingDashboardDisplay,
  discount : settingDashboardDisplay,
  printer : settingDashboardDisplay,
  floorPlan : settingDashboardDisplay,
  devices : settingDashboardDisplay
}

const styles = {
  deviceContainer : {
    display : 'flex',
    flexDirection : 'column',
    alignItems : 'center',
    position : 'relative'
  },
  avaliableBrowsers : {
    display : 'flex',
    flexDirection : 'row',
    alignItems : 'center',
    justifyContent : 'center',
    paddingBottom : '20px'
  }
}

class WebAppDeviceDisplay extends Component {
  render() {
    const { featureSelected } = this.props;
    return (
      <Grid.Column only="computer" style={styles.deviceContainer} width={6}>
        <Grid>
          <Grid.Row style={{ padding : '0px' }}>
            <Grid.Column style={styles.avaliableBrowsers}>
              <Icon name='chrome' size='big' color='black'/>
              <Icon name='firefox' size='big' style={{ color : ThemeColorSetting.grey }}/>
              <Icon name='safari' size='big' style={{ color : ThemeColorSetting.grey }}/>
              <Icon name='internet explorer' size='big' style={{ color : ThemeColorSetting.grey }}/>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ padding : '0px'}}>
            <Grid.Column style={{ display : 'flex' , flexDirection : 'column' , alignItems : 'center', justifyContent : 'center'   }}>
              <Image src={deviceDisplay[featureSelected]} style={{ width : '20%' , top : '30vh' , position : 'fixed'  }}/>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Column>
    );
  }
}

export default connect(null,null)(WebAppDeviceDisplay)



/** WEBPACK FOOTER **
 ** ./src/containers/features/webAppDeviceDisplay.js
 **/